
GrouponValidate =

  # Returns true if the value is a valid email address
  email: (value) ->
    return false if !value? or value.length > 100
    emailValidRegex = "^((\\\"[^\\\"\\f\\n\\r\\t\\v\\b]+\\\")|([\\.\\w=\\!\\#\\$\\%\\&\\'\\*\\+\\-\\~\\/\\^\\`\\|\\{\\}]+))@((\\[(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))\\])|(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))|((([A-Za-z0-9\\-])+\\.)+[A-Za-z\\-]+))$"
    validMatch = new RegExp(emailValidRegex)
    emailInvalidRegex= "<|`"
    invalidMatch = new RegExp(emailInvalidRegex)
    return validMatch.test(value) and not invalidMatch.test(value)

  cartId: (value) ->
    cartIdValidRegex = /^\d{4}-\d{6}-\d{6}$/
    return cartIdValidRegex.test(value)

  zip: (value) ->
    return false if value == '' || value == 'undefined'
    zip = $.trim(value)
    regexp  = /(^([0-9]{5}(-[0-9]{4})?)$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/
    regexp.test(zip)

  phone: (value) ->
    return false if value.length == 0
    phone = $.trim(value)
    regExp = /^(?:\d{3}|\(\d{3}\))(?: *|-?)\d{3}(?: *|-?)\d{4}$/
    regExp.test(phone)

  phoneInternational: (value) ->
    return false if value.length == 0
    phone = $.trim(value)
    regExp = /^[0-9]+$/
    if regExp.test phone
      return true
    regExp = /(?=^[\( *\-*\) *0-9+]*$)(?=^(?!\-+))(?=\((\d{1,} *\d{0,})\)|\((\d{1,}\-*\d{0,})\)|\((\d{1,})\))/m
    regExp1 = /^[ *\-* *0-9+]*$/
    if regExp.test(phone)
      return true
    else
      return regExp1.test phone

  creditCard: (value) ->
    return false if value.length == 0
    description = $.trim(value)
    regExp = /(cc#\s|credit\scard\s|Visa\s|visa\s|mastercard\s|Mastercard\sAmerican\s|american\sJCB\s|jcb\s|Discover\s|discover\s)((?:(?:4\d{3})|(?:5[1-5]\d{2})|6(?:011|5[0-9]{2}))(?:-?|\s*)(?:\d{4}(?:-?|\s*)){3}|(?:3[4,7]\d{2})(?:-?|\s*)\d{6}(?:-?|\s*)\d{5}|(?:2131|1800|3088|3337|3096\d{11})|((35\d{2}-?\s?)(\d{4}(-?\s?))))/
    regExp.test(description)

module.exports = GrouponValidate
